// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/schuko-klammer/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchukoKlammerDE: PageEntry = {
  id: "example.produkte-schuko-klammer",
  locale: "de",
  slug: "produkte/schuko-klammer",
  seo: {
    title: "Schuko-Klammer | Dietz GmbH",
    description: "Einsatz in hochmodernen und modularen Steckdosensystemen für den Smart-Home-Bereich. Nutzen von Legierungen, die günstiger sind als die standardmäßig eingesetzten NE-Metalle – ohne",
  },
  type: "post",
  h1: "Schuko-Klammer",
  intro: "Einsatz in hochmodernen und modularen Steckdosensystemen für den Smart-Home-Bereich. Nutzen von Legierungen, die günstiger sind als die standardmäßig eingesetzten NE-Metalle – ohne Qualitätseinbußen.",
  blocks: [
    { kind: "image", src: "/images/live/prod_stanz-umformtechnik.jpg", alt: "Schutzkontakt-Klammer Bauteil Stanz- Umformtechnik DIETZ", width: 1280, height: 1024 }
  ],
};
